import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';
import { CmdbSyncHistorySkeletonComponent } from '../cmdb-sync-history-skeleton/cmdb-sync-history-skeleton.component';

@Component({
  selector: 'app-cmdb-sync-skeleton',
  templateUrl: './cmdb-sync-skeleton.component.html',
  styleUrls: ['./cmdb-sync-skeleton.component.scss'],
  imports: [SkeletonComponent, CmdbSyncHistorySkeletonComponent],
})
export class CmdbSyncSkeletonComponent {
  readonly tabs = [1, 2, 3];
}